import * as Sentry from '@sentry/browser'
import { ErrorWithExtra } from '~/utils/error'

const beforeSend: Sentry.BrowserOptions['beforeSend'] = (event, hint) => {
  const error = hint.originalException
  if (error instanceof ErrorWithExtra) {
    event.extra = {
      ...event.extra,
      ...error.extra,
    }
  }
  return event
}

export const initializeSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: `harami_report@${import.meta.env.VITE_APP_VERSION}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // NOTE: makeBrowserOfflineTransport を使用することで、
    // オフライン時は IndexedDB にイベントを保存し、オンライン時に送信するようになる
    // また、保持件数などを変更する場合は、 transportOptions を使用する
    // transportOptions については、以下のリンクを参照
    // https://docs.sentry.io/platforms/javascript/best-practices/offline-caching/
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    tracePropagationTargets: [],
    // tracesSampleRate: 0.1,
    /**
     * 目的： HPB-6227 オンコール調査のため、特定条件下で確実にトレースを取得するため。
     * - 対象関数名: submitReport, saveInProgressReport
     * - 対象会社ID: 2, 1125(HPB-6227参照)
     * 削除予定日： 2026-1-28
     * 担当者： @kawanoRiku0
     */
    tracesSampler: samplingContext => {
      const defaultSampleRate = 0.1
      const targetNames = ['submitReport', 'saveInProgressReport']
      const targetCompanyIds = [2, 1125]

      const name = samplingContext.name
      const companyId = samplingContext.attributes?.companyId

      if (!companyId) return defaultSampleRate

      if (
        targetNames.includes(name) &&
        targetCompanyIds.includes(companyId as number)
      ) {
        return 1.0
      }

      return defaultSampleRate
    },
    replaysOnErrorSampleRate: 0.1,
    beforeSend,
  })
}
